// require('./bootstrap');

import Vue from 'vue';
import axios from 'axios';
import VueAxios from 'vue-axios';
import citySelect from "./components/city-select.vue";

window.Vue = require('vue');
Vue.use(VueAxios, axios);

/**
 * The following block of code may be used to automatically register your
 * Vue components. It will recursively scan this directory for the Vue
 * components and automatically register them with their "basename".
 *
 * Eg. ./components/ExampleComponent.vue -> <example-component></example-component>
 */

const files = require.context('./', true, /\.vue$/i)
files.keys().map(key => Vue.component(key.split('/').pop().split('.')[0], files(key).default))

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

// const app = new Vue({
//     el: '#app',
// });

Vue.directive('phone', {
    bind(el) {
        el.onpaste = function(e) {
            if (!e.isTrusted) {
                return;
            }

            var clipboardData, pastedData;
            // Get pasted data via clipboard API
            clipboardData = e.clipboardData || window.clipboardData;
            pastedData = clipboardData.getData('Text');
            if (pastedData[0] == 7 || pastedData[0] == 8) {
                pastedData = pastedData.slice(1);
                el.value = '+7' + pastedData;
            }
            if (pastedData[0] == '+' && pastedData[1] == 7) {
                el.value = pastedData;
            }
            el.dispatchEvent(new Event('input'));
        };
        el.oninput = function(e) {
            if (!e.isTrusted) {
                return;
            }
            const x = this.value.replace(/\D/g, '').match(/(\d{0,1})(\d{0,3})(\d{0,3})(\d{0,2})(\d{0,2})/);
            if (x[1] != 9) {
                x[1] = '+7';
            } else {
                x[1] = '+7';
                x[2] = '9';
            }

            if (x[2][0] == '7' || x[2][0] == '8') {
                x[2] = x[2].slice(1);
            }

            this.value = !x[3] ? x[1] + ' (' + x[2] : x[1] + ' (' + x[2] + ') ' + x[3] + (x[4] ? '-' + x[4] : '') + (x[5] ? '-' + x[5] : '');
            el.dispatchEvent(new Event('input'));

        }
    },
});

var headerCounters = document.querySelector(".module.top-module");
var formSteps = document.querySelectorAll(".form-steps-wrapper");
var formHotTours = document.getElementById("form_hot_tours");
var citySelects = document.querySelectorAll(".city-select-cnt");
var indexLinks = document.getElementById("index-links");
var addresses = document.getElementById("header-address");
var loan = document.getElementById("loan");

formSteps.forEach((form_)=>{
    const vueSteps = new Vue({
        el: form_,
    });
})

if (formHotTours) {
    const vueTours = new Vue({
        el: formHotTours,
    });
}
if (citySelects) {
    citySelects.forEach((citySelect)=>{
        new Vue({
            el: citySelect,
        });
    })
}
if (indexLinks) {
    const vueIndexLinks = new Vue({
        el: indexLinks,
    });
}
if (addresses) {
    const vueAddresses = new Vue({
        el: addresses,
    });
}
if (loan) {
    const vueLoan = new Vue({
        el: loan,
    });
}
if (headerCounters) {
    const vueHeaderCounters = new Vue({
        el: headerCounters,
    });
}

var timer = null;
window.addEventListener('scroll', function() {
    document.querySelector('body').classList.add('scrolling')
    if(timer !== null) {
        clearTimeout(timer);
    }
    timer = setTimeout(function() {
        document.querySelector('body').classList.remove('scrolling')
    }, 150);
}, false);
